<div class="maintenance-wrapper" >
  <article>
    <div class="maintenance-wrap" [ngStyle]="{'background': 'url(' + maintenanceBg + ') no-repeat center top/cover'}">
      <div class="maintenance-middle-align">
        <div class="maintenance-header">
          <!-- <img src="{{siteUrlPath}}/{{mediaUrlPath}}/maintenance.png" alt="maintenance" /> -->
          <h1>{{'maintainance.maintenance1' | translate}}</h1>
          <p>{{'maintainance.maintenance2' | translate}}</p>
        </div>
        <div class="maintenance-body">
          <div class="maintenance-body__item">
            <div class="maintenance-body__item--img">
              <img src="{{siteUrlPath}}/{{mediaUrlPath}}/maintence-item-1.png" alt="maintenance" />
            </div>
            <div class="maintenance-body__item--content">
              <h3>{{'maintainance.maintenance3' | translate}}</h3>
              <p>{{'maintainance.maintenance4' | translate}}</p>
            </div>
          </div>
          <div class="maintenance-body__item">
            <div class="maintenance-body__item--img">
              <img src="{{siteUrlPath}}/{{mediaUrlPath}}/maintence-item-2.png" alt="maintenance" />
            </div>
            <div class="maintenance-body__item--content">
              <h3>{{'maintainance.maintenance5' | translate}}</h3>
              <p>{{'maintainance.maintenance6' | translate}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</div>
